import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { useSelector } from 'react-redux';
import { device } from '../../styles/devices';
import { LOCATION_SEARCH_MODAL_OPEN_EVENT } from '../../constants';
import FilterDrawer from '../Filters/FilterDrawer';
import { VehicleResults } from './VehicleResultsContainer.styles';
import VehicleList from '../VehicleList/VehicleList';
import ShowFilterCTA from './ShowFilterCTA';
import useScrollTracker, {
  useMainComponentScrollTracker,
  useScrollVerticalTracker,
} from '../../hooks/UI/useScrollTracker';
import { selectAppConfig } from '../../redux/appConfigReducer';
import { selectFilters } from '../../redux/filtersReducer';
import useGetStockCarSearch from '../../hooks/Fetch/useGetStockCarSearch';
import { selectVehiclesOneGraph } from '../../redux/vehiclesReducer';

const VehicleResultsContainer: React.FC = () => {
  const isLaptop = useMediaQuery({ query: device.laptop });

  const { isTier3page, filterTrayState } = useSelector(selectAppConfig);

  const [isFiltersOpen, setIsFiltersOpen] = useState(filterTrayState === 'open' && isLaptop);

  useEffect(() => {
    setIsFiltersOpen(filterTrayState === 'open' && isLaptop);
  }, [filterTrayState, isLaptop]);

  const { confirmedFilters } = useSelector(selectFilters);
  const { handleLoadMore, loading, error } = useGetStockCarSearch();

  // Get Non Audi counts
  // ----------------------------------------------------------------------
  // useGetNonAudiModelsCount(isTier3page, confirmedFilters.partnerDealers);
  // ----------------------------------------------------------------------

  const { t, i18n } = useTranslation();
  const lang = i18n.languages?.[0] || 'en';

  const onLocationSearchOpen = useCallback(() => {
    const event = new CustomEvent(LOCATION_SEARCH_MODAL_OPEN_EVENT);
    document.dispatchEvent(event);
  }, []);

  const listRef = useRef(null);

  const isReachedEndOfContainer = useScrollVerticalTracker(listRef);

  const distanceFromTopToMainComponent = useMainComponentScrollTracker(listRef);

  const scrolled = useScrollTracker(distanceFromTopToMainComponent - 28);

  const isVehiclesLoading = loading;

  return (
    <VehicleResults ref={listRef}>
      <FilterDrawer
        isFiltersOpen={isFiltersOpen}
        setIsFiltersOpen={setIsFiltersOpen}
        isReachedEndOfContainer={isReachedEndOfContainer}
        isVehiclesLoading={isVehiclesLoading}
      />
      {!isFiltersOpen && isLaptop && (
        <ShowFilterCTA
          isFiltersOpen={isFiltersOpen}
          setIsFiltersOpen={setIsFiltersOpen}
          scrolled={scrolled}
        />
      )}

      <VehicleList
        loading={loading}
        onLocationSearchOpen={onLocationSearchOpen}
        setIsFiltersOpen={setIsFiltersOpen}
        fetchMore={handleLoadMore}
        isLaptop={isLaptop}
        isFiltersOpen={isFiltersOpen}
      />
    </VehicleResults>
  );
};

export default VehicleResultsContainer;
